import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import {
  filterArrayWithMandatoryItems,
} from '../../AmexMarketingUtils/AmexUtils';
import DeltaWifiEditorialCard from './DeltaWifiEditorialCard';
import './DeltaWifiEditorial.scss';

const DeltaWifiEditorial = (props) => {
  const {
    matchMedia,
    baseRequestUrl,
    folderName,
    editorial,
    editorialContent,
    analyticsEvent,
  } = props;

  const { heading, content } = editorial;
  const { md } = matchMedia;
  const requiredKeys = ['image', 'title', 'url'];
  const filteredEditorialCards = filterArrayWithMandatoryItems(requiredKeys, editorialContent, 'Editorials');
  const sizeOfEditorial = filteredEditorialCards.length;
  if (sizeOfEditorial < 3) return null;

  const sanitizedContent = sanitizeString(content);

  return (
    <section className="DeltaWifiEditorial__section">
      <div className="container">
        <div className="DeltaWifiEditorial__Title">
          <h2 className="DeltaWifiEditorial__Title--heading">{heading}</h2>
          {!content && (
            <div
              className="DeltaWifiEditorial__Title--nocontent"
            />
          )}
          {content && (
            <div
              className="DeltaWifiEditorial__Title--content"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: sanitizedContent,
              }}
            />
          )}
        </div>
        <div className={cx('DeltaWifiEditorial__Wrapper', {
          'DeltaWifiEditorial__Wrapper--md': md,
        })}
        >
          <div className={cx('DeltaWifiEditorial__Grid', {
            'blog--3': (sizeOfEditorial === 3),
            'blog--4': (sizeOfEditorial === 4),
          })}
          >
            {filteredEditorialCards.map((post, index) => {
              const {
                url,
                title,
                image,
              } = post;

              return (
                <DeltaWifiEditorialCard
                  // eslint-disable-next-line react/no-array-index-key
                  key={`post_${index}`}
                  url={url}
                  title={title}
                  image={`${baseRequestUrl}DeltaWifi/editorialData/${folderName}/images/${image}`}
                  containerQuery={matchMedia}
                  analyticsEvent={analyticsEvent}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

DeltaWifiEditorial.propTypes = {
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  folderName: PropTypes.string.isRequired,
  editorial: PropTypes.shape({
    heading: PropTypes.string, content: PropTypes.string,
  }).isRequired,
  editorialContent: PropTypes.arrayOf({
  }).isRequired,
  analyticsEvent: PropTypes.func.isRequired,
};

export default DeltaWifiEditorial;
